/**
 * useFaqSeo - FAQ 结构化数据生成和注入
 * 
 * 功能：
 * 1. 为 FAQ 问答生成 FAQPage Schema.org 结构化数据
 * 2. 通过 useHead 注入结构化数据到页面
 */

import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useHead } from '#app'

export interface FaqItem {
    question: string
    answer: string
}

/**
 * 为 FAQ 问答生成 FAQPage 结构化数据并注入到页面
 * 
 * @param faqs FAQ 数组，支持响应式
 */
export function useFaqSeo(faqs: MaybeRefOrGetter<FaqItem[]>) {
    const faqData = computed(() => {
        const faqsValue = toValue(faqs)
        
        if (!faqsValue || faqsValue.length === 0) {
            return null
        }

        return {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqsValue.map((faq: FaqItem) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer,
                },
            })),
        }
    })

    useHead({
        script: [
            {
                key: 'faq-schema',
                type: 'application/ld+json',
                innerHTML: computed(() => {
                    const data = faqData.value
                    return data ? JSON.stringify(data) : ''
                }),
            },
        ],
    })
}
